//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated by the ProcessTemplatesAfterBuild executable.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
(function () {
    "use strict";

    angular.module("app").factory("requestHistory", RequestHistoryFactory);

    RequestHistoryFactory.$inject = ["apiClientFactory"];
    function RequestHistoryFactory(apiClientFactory) {

        const routePrefix = "api/history/";

        return {
            FscRequestHistoryExtract: apiClientFactory.getFile(routePrefix + "fsc-request/"),
            PscRequestHistoryExtract: apiClientFactory.getFile(routePrefix + "psc-request/"),
        };
    }
})();
